import { Box, Button, FormControlLabel, Switch, Typography } from '@mui/material';
import { horizonShadingEnabled } from '../config/horizonShading';

export default function HorizonShadingControl({ config, greek, onChange, onFetch, busy, error }) {
  const t = (el, en) => greek ? el : en;
  const enabled = horizonShadingEnabled(config);
  const po = config?.panelOrientation || {};
  const points = Array.isArray(po.horizonProfile) ? po.horizonProfile : Object.entries(po.horizonProfile || {});
  const available = points.filter(p => Array.isArray(p) && p.length >= 2 &&
    p[0] != null && p[1] != null && Number.isFinite(Number(p[0])) && Number.isFinite(Number(p[1]))).length >= 2;
  const site = po.horizonProfileSite;
  const lat = config?.loc_info?.lat ?? config?.lat;
  const lon = config?.loc_info?.lon ?? config?.lon;
  const outdated = available && site && lat != null && lon != null &&
    (Math.abs(Number(site.lat) - Number(lat)) > 1e-4 || Math.abs(Number(site.lon) - Number(lon)) > 1e-4);
  return <Box sx={{ mb: 1.25 }}>
    <FormControlLabel sx={{ m: 0 }} label={t('Σκίαση ορίζοντα', 'Horizon shading')}
      control={<Switch size="small" checked={enabled} onChange={(_, checked) => onChange(checked)} />} />
    <Typography variant="caption" display="block" color={enabled && (!available || outdated) ? 'warning.main' : 'text.secondary'} role="status">
      {!enabled ? t('Ο ορίζοντας δεν λαμβάνεται υπόψη.', 'The horizon is not included.')
        : !available ? t('Δεν υπάρχει διαθέσιμο προφίλ ορίζοντα· η σκίασή του δεν υπολογίζεται μέχρι να γίνει λήψη.', 'No horizon profile is available; its shading is not calculated until a profile is fetched.')
        : outdated ? t('Το προφίλ αφορά άλλη τοποθεσία. Ανανεώστε το πριν από τον υπολογισμό.', 'The profile belongs to another location. Refresh it before calculating.')
        : config?.pvLosses?.dc?.shadingMode === 'geometry'
          ? t('Ο μακρινός ορίζοντας υπολογίζεται χωριστά από τις σκιάσεις της διάταξης.', 'The terrain horizon is calculated separately from layout shading.')
          : t('Ο μακρινός ορίζοντας υπολογίζεται χωριστά. Το ποσοστό αφορά πρόσθετες σκιάσεις, χωρίς τον ορίζοντα.', 'The terrain horizon is calculated separately. The percentage covers additional shading, excluding the horizon.')}
    </Typography>
    {enabled && (!available || outdated) && onFetch && <Button size="small" disabled={busy} onClick={onFetch}>
      {busy ? t('Λήψη…', 'Fetching…') : t('Λήψη ορίζοντα', 'Fetch horizon')}
    </Button>}
    {error && <Typography variant="caption" color="error" display="block">
      {t('Δεν ήταν δυνατή η λήψη του ορίζοντα. Δοκιμάστε ξανά.', 'Could not fetch the horizon. Please try again.')}
    </Typography>}
  </Box>;
}
